<template>
    <div class="adBack">
        <img class="img" src="../../assets/ad/quard1.png">
        <img class="img" src="../../assets/ad/quard2.png">
        <img class="img" src="../../assets/ad/quard3.png">
        <img class="img" src="../../assets/ad/quard4.png">
        <img class="img" src="../../assets/ad/quard5.png">
        <img class="img" src="../../assets/ad/quard6.png">
        <img class="img" src="../../assets/ad/quard7.png">
        <img class="img" src="../../assets/ad/quard8.png">
        <img class="img" src="../../assets/ad/quard9.png">
        <img class="img" src="../../assets/ad/quard10.png">
        <img class="img" src="../../assets/ad/quard11.png">
        <img class="img" src="../../assets/ad/quard12.png">
        <div class="footer">
            <div class="footer-button" @click="lookDetail"><img src="../../assets/ad/buy.png"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DoorGuard",
        methods:{
            lookDetail(){
                window.location.href="https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.50111debZ1fvWI&ft=t&id=574491580688";
            }
        }
    }
</script>

<style scoped lang="less">
.adBack{
    background: #ffffff;
    min-height: 100%;
    .img{
        width: 100%;
        height: 100%;
        margin-top: -1vh;
    }
}
.footer{
    height: 20vh;
    .footer-button{
        background: #333;
        width: 70vw;
        height: 13vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }
    img{
        width: 20vw;
    }
}
</style>
